import { FormattedMessage } from 'react-intl';

import styles from './PromptSave.module.css';
import ConfirmationButton from '../../ui/confirmationButton/ConfirmationButton';
import { Prompt } from '../../ui/prompt';

export const PromptSave = (props) => {
    const { openPrompt, handleCancelPrompt, handleSubmitPrompt, loading } =
        props;

    if (openPrompt) {
        return (
            <Prompt className={styles.PromptSave}>
                <button onClick={handleCancelPrompt}>
                    <FormattedMessage
                        id="_.your_company.prompt.cancel"
                        defaultMessage="Cancel"
                    />
                </button>
                <ConfirmationButton
                    onClick={handleSubmitPrompt}
                    loading={loading}
                >
                    <FormattedMessage
                        id="_.your_company.prompt.save"
                        defaultMessage="Save"
                    />
                </ConfirmationButton>
            </Prompt>
        );
    } else {
        return null;
    }
};
